import { timeFormat } from 'd3-time-format'
import { timeSecond, timeMinute, timeHour, timeDay } from 'd3-time'

import dateService, { toStrftime } from 'live/services/date'
const formatSecond = timeFormat(toStrftime(dateService.getTimeFormat()))
const formatMinute = timeFormat(toStrftime(dateService.getTimeShort()))
const formatHour = timeFormat(toStrftime(dateService.getTimeShort()))
const formatDay = timeFormat('%e. %b')

export default function (date: Date): string {
    return (timeMinute(date) < date
        ? formatSecond
        : timeHour(date) < date
        ? formatMinute
        : timeDay(date) < date
        ? formatHour
        : formatDay)(date)
}
